// "use client";
// import { useRouter } from "next/router";
// import Header from "../../components/common/Header";
// import LatestNews from "../../components/latest-news";
// import CommonBanner2 from "../common/CommonBanner2";
// import FaqSection from "../../components/common/FaqSection";
// import Footer from "../../components/footer";
// import { useTranslation } from "next-i18next";

// const News = ({ initialNews = [], initialTotalPages = 1 }) => {
//   const { t } = useTranslation("news");
//   const router = useRouter();

//   const page = Math.max(parseInt(router.query.page || "1", 10), 1);

//   const faqs = [0, 1, 2, 3].map((i) => ({
//     question: t(`news.faqs.${i}.question`),
//     answer: t(`news.faqs.${i}.answer`),
//   }));

//   return (
//     <>
//       <Header />
//       <main className="w-full box-border bg-background-color-primary overflow-hidden">
//         <CommonBanner2
//           name={t("news.banner.title")}
//           breadcrumbProps={{
//             labelMap: {
//               home: t("Home"),
//               news: t("News"), // or "Events"
//             },
//           }}
//         />

//         <section className="w-full self-stretch flex flex-row items-start justify-start py-[40px] lg:py-[60px] px-6 sm:px-6 lg:px-20 box-border max-w-[1600px] mx-auto">
//           <LatestNews
//             news={initialNews}
//             loading={false}
//             page={page}
//             totalPages={initialTotalPages}
//           />
//         </section>
//         <FaqSection faqs={faqs} />
//       </main>
//       <Footer />
//     </>
//   );
// };

// export default News;

// main-pages/News.js
import { useRouter } from "next/router";
import Header from "../../components/common/Header";
import LatestNews from "../../components/latest-news";
import CommonBanner2 from "../common/CommonBanner2";
import FaqSection from "../../components/common/FaqSection";
import Footer from "../../components/footer";
import { useTranslation } from "next-i18next";

const parsePage = (value) => {
  const n = parseInt(value || "1", 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
};

const News = ({ initialNews = [], initialTotalPages = 1 }) => {
  const { t } = useTranslation("news");
  const router = useRouter();

  const page = parsePage(router.query.page);

  const faqs = [0, 1, 2, 3].map((i) => ({
    question: t(`news.faqs.${i}.question`),
    answer: t(`news.faqs.${i}.answer`),
  }));

  return (
    <>
      <Header />
      <main className="w-full box-border bg-background-color-primary overflow-hidden">
        <CommonBanner2
          name={t("news.banner.title")}
          breadcrumbProps={{
            labelMap: {
              home: t("Home"),
              news: t("News"),
            },
          }}
        />

        <section className="w-full self-stretch flex flex-row items-start justify-start py-[40px] lg:py-[60px] px-6 sm:px-6 lg:px-20 box-border max-w-[1600px] mx-auto">
          <LatestNews
            news={initialNews}
            loading={false}
            page={page}
            totalPages={initialTotalPages}
          />
        </section>
        <FaqSection faqs={faqs} />
      </main>
      <Footer />
    </>
  );
};

export default News;